export default __webpack_public_path__ + "static/media/logo.42fe1c90.svg";